var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var fetch = require('lets-fetch');

var nullCache = require('./cache/null');

var endpoints = require('./endpoints');

var flow = require('./flow');

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function Client() {
    _classCallCheck(this, Client);

    this.lang = 'en';
    this.apiKey = false;
    this.fetch = fetch;
    this.caches = [nullCache()];
    this.debug = false;
    this.client = this;
  } // Set the language for locale-aware endpoints


  _createClass(Client, [{
    key: "language",
    value: function language(lang) {
      this.lang = lang;
      this.debugMessage("set the language to ".concat(lang));
      return this;
    } // Set the api key for authenticated endpoints

  }, {
    key: "authenticate",
    value: function authenticate(apiKey) {
      this.apiKey = apiKey;
      this.debugMessage("set the api key to ".concat(apiKey));
      return this;
    } // Set the caching storage method(s)

  }, {
    key: "cacheStorage",
    value: function cacheStorage(caches) {
      this.caches = [].concat(caches);
      this.debugMessage("updated the cache storage");
      return this;
    } // Set the debugging flag

  }, {
    key: "debugging",
    value: function debugging(flag) {
      this.debug = flag;
      return this;
    } // Print out a debug message if debugging is enabled

  }, {
    key: "debugMessage",
    value: function debugMessage(string) {
      if (this.debug) {
        console.log("[gw2api-client] ".concat(string));
      }
    } // Make sure we get the new content if the game updates

  }, {
    key: "flushCacheIfGameUpdated",
    value: function flushCacheIfGameUpdated() {
      var _this = this;

      var buildEndpoint = this.build();
      var promises = {
        cacheBuildId: function cacheBuildId() {
          return buildEndpoint._cacheGetSingle('cacheBuildId');
        },
        buildId: function buildId() {
          return buildEndpoint.live().get();
        }
      };
      return flow.parallel(promises).then(function (resp) {
        var flushPromises = []; // Flush the caches if the cached build id is set (as a safety measure)
        // and the cached build id is older than the current one

        if (resp.cacheBuildId && resp.cacheBuildId < resp.buildId) {
          _this.debugMessage("flushing the cache because of a new build");

          flushPromises = _this.caches.map(function (cache) {
            return function () {
              return cache.flush();
            };
          });
        } // Flush the caches (if needed) and save the current build id


        return flow.parallel(flushPromises).then(function () {
          return buildEndpoint._cacheSetSingle('cacheBuildId', resp.buildId);
        });
      });
    } // All the different API endpoints

  }, {
    key: "account",
    value: function account() {
      return new endpoints.AccountEndpoint(this);
    }
  }, {
    key: "achievements",
    value: function achievements() {
      return new endpoints.AchievementsEndpoint(this);
    }
  }, {
    key: "backstory",
    value: function backstory() {
      return new endpoints.BackstoryEndpoint(this);
    }
  }, {
    key: "build",
    value: function build() {
      return new endpoints.BuildEndpoint(this);
    }
  }, {
    key: "cats",
    value: function cats() {
      return new endpoints.CatsEndpoint(this);
    }
  }, {
    key: "characters",
    value: function characters(name) {
      return new endpoints.CharactersEndpoint(this, name);
    }
  }, {
    key: "colors",
    value: function colors() {
      return new endpoints.ColorsEndpoint(this);
    }
  }, {
    key: "commerce",
    value: function commerce() {
      return new endpoints.CommerceEndpoint(this);
    }
  }, {
    key: "continents",
    value: function continents() {
      return new endpoints.ContinentsEndpoint(this);
    }
  }, {
    key: "currencies",
    value: function currencies() {
      return new endpoints.CurrenciesEndpoint(this);
    }
  }, {
    key: "dungeons",
    value: function dungeons() {
      return new endpoints.DungeonsEndpoint(this);
    }
  }, {
    key: "emblem",
    value: function emblem() {
      return new endpoints.EmblemEndpoint(this);
    }
  }, {
    key: "events",
    value: function events() {
      return new endpoints.EventsEndpoint(this);
    }
  }, {
    key: "files",
    value: function files() {
      return new endpoints.FilesEndpoint(this);
    }
  }, {
    key: "finishers",
    value: function finishers() {
      return new endpoints.FinishersEndpoint(this);
    }
  }, {
    key: "gliders",
    value: function gliders() {
      return new endpoints.GlidersEndpoint(this);
    }
  }, {
    key: "guild",
    value: function guild(id) {
      return new endpoints.GuildEndpoint(this, id);
    }
  }, {
    key: "items",
    value: function items() {
      return new endpoints.ItemsEndpoint(this);
    }
  }, {
    key: "itemstats",
    value: function itemstats() {
      return new endpoints.ItemstatsEndpoint(this);
    }
  }, {
    key: "legends",
    value: function legends() {
      return new endpoints.LegendsEndpoint(this);
    }
  }, {
    key: "mailcarriers",
    value: function mailcarriers() {
      return new endpoints.MailcarriersEndpoint(this);
    }
  }, {
    key: "maps",
    value: function maps() {
      return new endpoints.MapsEndpoint(this);
    }
  }, {
    key: "masteries",
    value: function masteries() {
      return new endpoints.MasteriesEndpoint(this);
    }
  }, {
    key: "materials",
    value: function materials() {
      return new endpoints.MaterialsEndpoint(this);
    }
  }, {
    key: "minis",
    value: function minis() {
      return new endpoints.MinisEndpoint(this);
    }
  }, {
    key: "mounts",
    value: function mounts() {
      return new endpoints.MountsEndpoint(this);
    }
  }, {
    key: "nodes",
    value: function nodes() {
      return new endpoints.NodesEndpoint(this);
    }
  }, {
    key: "outfits",
    value: function outfits() {
      return new endpoints.OutfitsEndpoint(this);
    }
  }, {
    key: "pets",
    value: function pets() {
      return new endpoints.PetsEndpoint(this);
    }
  }, {
    key: "professions",
    value: function professions() {
      return new endpoints.ProfessionsEndpoint(this);
    }
  }, {
    key: "pvp",
    value: function pvp() {
      return new endpoints.PvpEndpoint(this);
    }
  }, {
    key: "quaggans",
    value: function quaggans() {
      return new endpoints.QuaggansEndpoint(this);
    }
  }, {
    key: "races",
    value: function races() {
      return new endpoints.RacesEndpoint(this);
    }
  }, {
    key: "raids",
    value: function raids() {
      return new endpoints.RaidsEndpoint(this);
    }
  }, {
    key: "recipes",
    value: function recipes() {
      return new endpoints.RecipesEndpoint(this);
    }
  }, {
    key: "skills",
    value: function skills() {
      return new endpoints.SkillsEndpoint(this);
    }
  }, {
    key: "skins",
    value: function skins() {
      return new endpoints.SkinsEndpoint(this);
    }
  }, {
    key: "specializations",
    value: function specializations() {
      return new endpoints.SpecializationsEndpoint(this);
    }
  }, {
    key: "stories",
    value: function stories() {
      return new endpoints.StoriesEndpoint(this);
    }
  }, {
    key: "titles",
    value: function titles() {
      return new endpoints.TitlesEndpoint(this);
    }
  }, {
    key: "tokeninfo",
    value: function tokeninfo() {
      return new endpoints.TokeninfoEndpoint(this);
    }
  }, {
    key: "traits",
    value: function traits() {
      return new endpoints.TraitsEndpoint(this);
    }
  }, {
    key: "worlds",
    value: function worlds() {
      return new endpoints.WorldsEndpoint(this);
    }
  }, {
    key: "wvw",
    value: function wvw() {
      return new endpoints.WvwEndpoint(this);
    }
  }]);

  return Client;
}();